import _, {isString} from 'lodash';

import {buildDraftComment} from '../../../helpers/models/commentHelpers';
import {ConversationModel} from '../../../models/api/conversationModel';
import {ConversationTrackerStagesEnum} from '../../../models/api/conversationTrackerModel';
import {SendActionsEnum} from '../../../models/api/messageModel';
import {updateConversationTrackersAction} from '../../../services/tasks/updateConversationTrackersAction';
import {ThunkAction} from '../../appThunk';
import {CellsContext} from '../../panels/cells/context/cellsContext';
import {saveCommentAsyncAction} from '../comments/saveCommentActions';
import {sendCommentAsyncAction} from '../comments/sendCommentAction';
import {getFindTeammate} from '../teammates/lazyTeammatesSelectors';
import {getUserId} from '../teammates/teammatesSelectors';

export function inviteToConversationAction(
  cellsContext: CellsContext,
  conversation: ConversationModel,
  trackerIds: ReadonlyArray<number | string>,
  commentText?: string,
): ThunkAction {
  return (dispatch) => {
    // If a comment was provided, post it.
    // No need to update the trackers since the comment route will do it.
    const trimmedCommentText = commentText && commentText.trim();
    if (trimmedCommentText) {
      dispatch(mentionInCommentAction(cellsContext, conversation, trackerIds, trimmedCommentText));
      return;
    }

    // Otherwise, add the trackers to the conversation.
    dispatch(
      updateConversationTrackersAction(conversation.id, {
        add: trackerIds,
        stage: ConversationTrackerStagesEnum.SUBSCRIBER,
      }),
    );
  };
}

function mentionInCommentAction(
  cellsContext: CellsContext,
  conversation: ConversationModel,
  trackerIds: ReadonlyArray<number | string>,
  commentText: string,
): ThunkAction {
  return (dispatch, getState) => {
    const state = getState();
    const findTeammate = getFindTeammate(state);
    const commentUrlBuilder = (uid: string) => `${conversation.url}/comments/${uid}`;
    const draftComment = buildDraftComment({
      urlBuilder: commentUrlBuilder,
      authorId: getUserId(state),
      conversationId: conversation.id,
    });

    // Mention all of the specified trackers.
    const mentions = _(trackerIds)
      .map((t) => {
        // Visitor.
        if (isString(t)) {
          return t;
        }

        // Teammate.
        const teammate = findTeammate(t, 'mentionInCommentAction');
        return teammate && teammate.alias;
      })
      .compact()
      .map((m) => `@${m}`)
      .join(' ');

    // Save the comment.
    dispatch(saveCommentAsyncAction(draftComment, {newText: `${mentions} ${commentText}`}));

    // Send the comment.
    dispatch(
      sendCommentAsyncAction({
        cellsContext,
        conversationId: conversation.id,
        commentUid: draftComment.uid,
        ignoreWarnings: true,
        sendAction: SendActionsEnum.SEND,
      }),
    );
  };
}
